import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule, routerReducer } from '@ngrx/router-store';

import { GameDayModule } from '@ipreo/muni-gameday';
import { SharedModule, SharedRoutedModule } from '@ipreo/muni-shared';
import { NorthstarModule } from '@ipreo/northstar';
import { SessionFacade } from './facades/session.facade';
import { AppComponent } from './app.component';
import { SessionResolver } from './resolvers/session.resolver';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { DealContainerComponent } from './components/deal-container/deal-container.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { GamedayDirectAuthInterceptor } from './interceptors/auth.interceptor';

import { HeaderComponent } from './components/header/header.component';

const urlParams = new URLSearchParams(window.location.search);
const tokenValidityInHours = 7;

if (urlParams.has('token')) {
  localStorage.setItem('token', urlParams.get('token'));
  const currentDate = new Date();
  currentDate.setHours(currentDate.getHours() + tokenValidityInHours);
  localStorage.setItem('refreshTime', currentDate.toISOString());

}

@NgModule({
  declarations: [
    AppComponent,
    DealContainerComponent,
    NotFoundComponent,
    HeaderComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    HttpClientModule,
    AppRoutingModule,
    NorthstarModule.forRoot({
      appName: environment.appName,
      appVersion: '1.0.0',
      devModules: [],
      logSettings: {
        interval: environment.polaris.logInterval
      },
      oidcSettings: {},
      envConfig: {
        northstar: {
          host: {
            api: environment.polaris.apiBaseUrl,
            registry: environment.polaris.registryUrl,
            ws: environment.polaris.wsUrl
          },
          env: environment.polaris.env,
          cupcakeMajorVersion: 2
        },
        params: {
          apiHost: environment.apiHost,
          muniApiHost: environment.muniApiHost,
          dealUpdateChannel: environment.dealUpdateChannel,
          env: environment.env,
          platform: 'polaris'
        }
      }
    }),
    GameDayModule,
    StoreRouterConnectingModule.forRoot(),
    StoreModule.forRoot({ router: routerReducer }),
    EffectsModule.forRoot([]),
    SharedModule,
    SharedRoutedModule
  ],
  providers: [
    SessionResolver,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GamedayDirectAuthInterceptor,
      multi: true
    },
    SessionFacade
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
